// MenuItem.tsx

import { Link } from 'react-router-dom';
import { ArrowDownSLine } from '../../utils/svgs';
import { MenuSubItem } from './SubItem';
import { MenuItemProps } from './types';

import m from "./menu.module.scss";

export const MenuItem = ({ name, slug, link, sub_section, openItem, handleOpenItem }: MenuItemProps) => {
    const hasSub = !!(sub_section && sub_section.length !== 0);

    // A seta de expandir fica em botão próprio, separado do link. Antes, o
    // onClick vivia no wrapper inteiro e o Link ficava dentro — qualquer
    // clique disparava toggle do submenu E navegação ao mesmo tempo, o
    // que confundia o estado. Agora cada ação tem alvo próprio.
    return (
        <div className={m.item}>
            <div className={m.item_name}>
                {link ? (
                    <Link to={link}>
                        <p>{name}</p>
                    </Link>
                ) : (
                    <p>{name}</p>
                )}
                <div
                    className={m.item_name_arrow}
                    role={hasSub ? "button" : undefined}
                    tabIndex={hasSub ? 0 : undefined}
                    onClick={(e) => {
                        if (!hasSub || !slug || !handleOpenItem) return;
                        e.stopPropagation();
                        handleOpenItem(slug);
                    }}
                >
                    {hasSub && <ArrowDownSLine color={"#000"} />}
                </div>
            </div>
            {sub_section && <MenuSubItem
                open={openItem}
                sections={sub_section}
                parent={slug}
            />}
        </div>
    )
}
